export const getUiState = (state) => state.common;
export const getAuthState = (state) => state.common;
export const getMeetingsState = (state) => state.common.meetings;
export const getHasSubscription = (state) => state.profile.has_subscription;
